import { Link } from "react-router-dom";
import { connect } from "react-redux";

var DataRouting = require("lib/routing/DataRouting");

var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var TopBarWarning = require("components/layout/TopBarWarning");
var CoinsNotificationContainer = require("components/notifications/CoinsNotificationContainer");
var SocialNotificationContainer = require("components/notifications/SocialNotificationContainer");
var SiteBanner = require("components/notifications/SiteBanner");
var StudentAvatar = require("components/avatars/StudentAvatar");
var Features = require("lib/account/Features");
var ImageIcon = require("components/utility/icons/ImageIcon");
var AccountPlans = require("lib/account/AccountPlans");

var RosterSelectors = require("lib/selectors/RosterSelectors");

require("layout/site_header.scss");

function selectStudentLists(state) {
	return CurrentUser.isAdmin() ? RosterSelectors.studentLists({ state }) : [];
}

@connect(
	(state, props) => {
		var downProps = { studentLists: selectStudentLists(state) }

		if (CurrentUser.isPassphraseUser()){
			downProps.rootPath = "/class_access?passphrase=" + CurrentUser.get().passphrase;
		} else {
			downProps.rootPath = "/"
		}

		return downProps
	},
	(dispatch, props) => ({
	})
)

class SiteHeader extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	logOut(e) {
		$wr.nope(e)
		CurrentUser.logOut();
		window.location = WhooosReadingServices.OuterPages.url("/");
	}

	renderHomeLink(){
		if (CurrentUser.isSponsor()) {
			var homeLink = (
				<span className="logoBox">
					<img src={ require("logos/wr-logo-white.png") } className="wrLogo" />
				</span>
			);
		} else {
			var homeLink = (
				<Link to={ this.props.rootPath } className="logoBox">
					<img src={ require("logos/wr-logo-white.png") } className="wrLogo" />
				</Link>
			)				
		}
		return homeLink
	}

	renderLoadingHeader(){
		var headerClassName = ""

		var leftNav = (
			<div className="leftNav">
				<span></span>
			</div>
		);

		var rightNavContainer = (
			<div className="rightNav">
				<Link to="/login/" className="loginButton">
					Log In
				</Link>
			</div>
		);
		var homeLink = (
			<Link to={ this.props.rootPath } className="logoBox">
				<img src={ require("logos/wr-logo-white.png") } className="wrLogo" />
			</Link>
		)
		// siteHeaderPlaceholder occupies space when the siteHeader becomes fixed
		return (
			<div className="hideOnPrint">
				<TopBarWarning />
				<div id="siteHeaderPlaceholder" ref="placeholder" style={{ display: "none" }} />
				<div id="siteHeader" className={ headerClassName } ref="header">
					<div className="container">
						{ leftNav }
						{ homeLink }
						{ rightNavContainer }
					</div>
				</div>
			</div>
		)
	}

	renderPendingSSOUserHeader(){
		var currentUser = CurrentUser.get()
		var homeLink = this.renderHomeLink()

		var dropdownLowerLinks = (
			<div>
				<li><a href="https://whooosreading.zendesk.com/hc" target="_blank">Help</a></li>

				<li onClick={ this.logOut }>
					<a href="" >Log Out</a>
				</li>
			</div>
		);

		var nameLine = currentUser.first_name;
		var rightNavContainer = (
			<div className="rightNav">
				<div className="dropdown">
					<a id="dLabel" role="button"
						data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="ellipsisText">{ nameLine }</span>
						<span className="caret"></span>
					  </a>

					<ul className="dropdown-menu" aria-labelledby="dLabel">
						{ dropdownLowerLinks }
					</ul>
				</div>
			</div>
		)
		// siteHeaderPlaceholder occupies space when the siteHeader becomes fixed
		return (
			<div className="hideOnPrint">
				<TopBarWarning />
				<div id="siteHeaderPlaceholder" ref="placeholder" style={{ display: "none" }} />
				<div id="siteHeader" ref="header">
					<div className="container">
						{ homeLink }
						{ rightNavContainer }
					</div>
				</div>
			</div>
		)
	}

	renderStudentHeader(){
		var headerClassName = "studentHeader";
		var currentUser = CurrentUser.get()
		if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
			var socialNotifications = (
				<span>
					<SocialNotificationContainer />
				</span>
			);
		}

		var rightShopLink = (
			<div className="owlShopContainer right">
				<Link to="/owl_shop">
					<StudentAvatar student={ currentUser } maxWidth={ 30 } disableSound={true} disableAnimation={true}/>
					<span>Shop</span>
				</Link>
			</div>
		)

		if (currentUser.display_class_shelf) {
			var classPagePath = "/student_lists/default/shelf";
		} else {
			var classPagePath = "/student_lists/default/tree";
		}

		var leftNav = (
			<div className="leftNav">
				<div className="myShelfContainer">
					<Link to="/my/shelf">
						<img src={ require("official-icons/book.png") } />
						<span>My Shelf</span>
					</Link>
				</div>
				<div className="myClassNavContainer">
					<Link to={ classPagePath }>
						<img src={ require("official-icons/class.png") } />
						<span>Class</span>
					</Link>
				</div>
				<div className="mySchoolNavContainer">
					<Link to="/contests">
						<ImageIcon icon="school" />
						<span>School</span>
					</Link>
				</div>
			</div>
		);
		var dropdownTopLinks = (
			<div>
				<li><Link to="/">My Home Page</Link></li>
			</div>
		)

		var dropdownLowerLinks = (
			<div onClick={ this.logOut }>
				<li><a className="logOutLink" href="" >Log Out</a></li>
			</div>
		)

		var rightNavContent = (
			<div className="rightNavContent">
				{ rightShopLink }
				<CoinsNotificationContainer />
				{ socialNotifications }
				<div className="verticalDivider" />
			</div>
		);

		var nameLine = currentUser.first_name;
		if (dropdownTopLinks && dropdownLowerLinks) {
			var dropdownDivider = (
				<div className="dropdownDivider"></div>
			);				
		}
		var rightNavContainer = (
			<div className="rightNav">
				{ rightNavContent }
				<div className="dropdown">
					<a id="dLabel" role="button"
						data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="ellipsisText">{ nameLine }</span>
						<span className="caret"></span>
					  </a>

					<ul className="dropdown-menu" aria-labelledby="dLabel">
						{ dropdownTopLinks }
						{ dropdownDivider }
						{ dropdownLowerLinks }
					</ul>
				</div>
			</div>
		)

		var siteBannerAlerts = _.filter(CurrentUser.get().user_alerts, function(alert) {
			return alert.type == "SiteBanner"
		});
			
		if (siteBannerAlerts.length > 0) {
			var siteBannerContent = (
				<SiteBanner alerts={ siteBannerAlerts } />
			);
		}

		var homeLink = this.renderHomeLink()

		return (
			<div className="hideOnPrint">
				<TopBarWarning />
				<div id="siteHeaderPlaceholder" ref="placeholder" style={{ display: "none" }} />
				<div id="siteHeader" className={ headerClassName } ref="header">
					<div className="container">
						{ leftNav }
						{ homeLink }
						{ rightNavContainer }
					</div>
				</div>
				{ siteBannerContent }
			</div>
		)
	}

	renderAdminHeader(){
		var headerClassName = "adminHeader"
		var currentUser = CurrentUser.get()


		var homeLink = this.renderHomeLink()

		var dropdownLowerLinks = (
			<div>
				<li><a href="https://whooosreading.zendesk.com/hc" target="_blank">Help</a></li>

				<li onClick={ this.logOut }>
					<a href="" >Log Out</a>
				</li>
			</div>
		);

		var dataLink = (
			<Link to={"/data"} className="dataLink">
				Data
			</Link>
		);

		var newLabel = (
			<span className="navStatus badge">
				New!
			</span>
		)
		var insightsLink = (
			<span>
				<Link to="/insights" className="insightsLink">
					Insights
				</Link>
				{newLabel}
			</span>
		);

		if (CurrentUser.isTeacherAdmin()) {
			if (CurrentUser.isPremiumOrTrialAccount()){
				var dropdownTopLinks = (
					<div>
						<li>
							<Link to="/settings/information">Settings</Link>
						</li>
						<li>
							<Link to="/questions">
								Question Search
							</Link>
						</li>
					</div>
				)
			} else {
				var dropdownTopLinks = (
					<div>
						<li>
							<Link to="/settings/information">Settings</Link>
						</li>
					</div>
				)
			}

			if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
				var exercisesLink = (
					<Link to="/activities/exercises" className="insightsLink">
						Activities
					</Link>
				);
			}
			else {
				var exercisesLink = (
					<Link to="/activities/teacher-picks" className="insightsLink">
						Picks
					</Link>
				)
			}

			var leftNav = (
				<div className="leftNav" id="adminLeftNav">
					{ dataLink }
					{ exercisesLink }
					{ insightsLink }
				</div>
			);

			var socialNotifications = null;

			var rightNavContent = (
				<div className="rightNavContent">
					<Link to="/contests" className="rightNavLink">
						School
					</Link>

					<Link to="/roster" className="rightNavLink">
						Roster
					</Link>
					<Link to="/student_lists/default/shelf" className="rightNavLink">Shelves</Link>
					{ socialNotifications }
				</div>
			);
			
		} else {
			var leftNav = (
				<div className="leftNav" id="adminLeftNav">
					{ dataLink }
					{ insightsLink }
				</div>
			);

			if (CurrentUser.isDistrictAdmin()) {
				var schoolText = "Schools";
			} else {
				var schoolText = "School";
			}

			var rightNavContent = (
				<div className="rightNavContent">
					<Link to="/contests" className="rightNavLink">
						{ schoolText }
					</Link>

					<Link to="/roster" className="rightNavLink">
						Roster
					</Link>
				</div>
			);

			var dropdownTopLinks = (
				<div>
					<li>
						<Link to="/settings/information">Settings</Link>
					</li>
				</div>
			);
		}


		if (dropdownTopLinks && dropdownLowerLinks) {
			var dropdownDivider = (
				<div className="dropdownDivider"></div>
			);				
		}

		var nameLine = currentUser.first_name;
		
		var rightNavContainer = (
			<div className="rightNav">
				{ rightNavContent }
				<div className="dropdown">
					<a id="dLabel" role="button"
						data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="ellipsisText">{ currentUser.first_name }</span>
						<span className="caret"></span>
					  </a>

					<ul className="dropdown-menu" aria-labelledby="dLabel">
						{ dropdownTopLinks }
						{ dropdownDivider }
						{ dropdownLowerLinks }
					</ul>
				</div>
			</div>
		)

		var siteBannerAlerts = _.filter(CurrentUser.get().user_alerts, function(alert) {
			return alert.type == "SiteBanner"
		});
			
		if (siteBannerAlerts.length > 0) {
			var siteBannerContent = (
				<SiteBanner alerts={ siteBannerAlerts } />
			);
		}

		// siteHeaderPlaceholder occupies space when the siteHeader becomes fixed
		return (
			<div className="hideOnPrint">
				<TopBarWarning />
				<div id="siteHeaderPlaceholder" ref="placeholder" style={{ display: "none" }} />
				<div id="siteHeader" className={ headerClassName } ref="header">
					<div className="container">
						{ leftNav }
						{ homeLink }
						{ rightNavContainer }
					</div>
				</div>
				{ siteBannerContent }
			</div>
		)
		
	}

	renderWizardHeader(){
		var currentUser = CurrentUser.get()
		var nameLine = currentUser.first_name;
		var dropdownLowerLinks = (
			<div>
				<li onClick={ this.logOut }><a className="logOutLink" href="" >Log Out</a></li>
			</div>
		);
		var leftNav = (
			<div className="leftNav">
				<div className="dropdown wizLink">
					<a id="dLabel" role="button"
						data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="ellipsisText">User Tools</span>
						<span className="caret"></span>
					</a>

					<ul className="dropdown-menu" aria-labelledby="dLabel">
						<li>
							<Link to="/users/search" className="wizLink">
								Power Drill
							</Link>
						</li>
						<li>
							<Link to="/merge_students" className="wizLink">
								Merge Students
							</Link>
						</li>
						<li>
							<Link to='/digests_page' className='wizLink'>
								Digests Page
							</Link>
						</li>
					</ul>
				</div>

				<div className="dropdown wizLink">
					<a id="dLabel" role="button"
						data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="ellipsisText">CRM Tools</span>
						<span className="caret"></span>
					</a>

					<ul className="dropdown-menu" aria-labelledby="dLabel">
						<li>
							<Link to="/new_deal?contact_id=???">
								New Deal
							</Link>
						</li>
						<li>
							<Link to="/new_quotes?deal_id=???">
								New Quotes
							</Link>
						</li>
						<li>
							<Link to="/received?deal_id=???">
								PO/Payment Accepted
							</Link>
						</li>
						<li>
							<Link to="/upgrade_tokens">
								Upgrade Tokens
							</Link>
						</li>
						<li>
							<Link to="/discount_tokens">
								Discount Tokens
							</Link>
						</li>
						<li>
							<Link to="/deal_transforms?deal_id=???">
								Deal Transforms
							</Link>
						</li>
					</ul>
				</div>
			</div>
		);

		var rightNavContent = (
			<div className="rightNavContent">
				<Link to="/school_orgs" className="rightNavLink">
						School Orgs
				</Link>
				<Link to="/district_orgs" className="rightNavLink">
						District Orgs
				</Link>
			</div>
		);


	
		var rightNavContainer = (
			<div className="rightNav">
				{ rightNavContent }
				<div className="dropdown">
					<a id="dLabel" role="button"
						data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<span className="ellipsisText">{ nameLine }</span>
						<span className="caret"></span>
						</a>

					<ul className="dropdown-menu" aria-labelledby="dLabel">
						{ dropdownLowerLinks }
					</ul>
				</div>
			</div>
		)

		var homeLink = this.renderHomeLink()
		return (
			<div className="hideOnPrint">
				<TopBarWarning />
				<div id="siteHeaderPlaceholder" ref="placeholder" style={{ display: "none" }} />
				<div id="siteHeader" className="" ref="header">
					<div className="container">
						{ leftNav }
						{ homeLink }
						{ rightNavContainer }
					</div>
				</div>
			</div>
		)
		
	}

	renderSponsorHeader(){
		var homeLink = this.renderHomeLink()

		// Make it an <a>, not a <Link> so the page is forced to reload
		var rightNavContainer = (
			<div className="rightNav">
				<a href="/login" className="loginButton">
					Log In As Student
				</a>
			</div>
		);

		var siteBannerAlerts = _.filter(CurrentUser.get().user_alerts, function(alert) {
			return alert.type == "SiteBanner"
		});
			
		if (siteBannerAlerts.length > 0) {
			var siteBannerContent = (
				<SiteBanner alerts={ siteBannerAlerts } />
			);
		}

		return (
			<div className="hideOnPrint">
				<TopBarWarning />
				<div id="siteHeaderPlaceholder" ref="placeholder" style={{ display: "none" }} />
				<div id="siteHeader" ref="header">
					<div className="container">
						{ homeLink }
						{ rightNavContainer }
					</div>
				</div>
				{ siteBannerContent }
			</div>
		)
	}


	render() {
		if (CurrentUser.isLoaded()) {
			if (CurrentUser.isPendingSSOUser()) {
				return this.renderPendingSSOUserHeader()
			} else if (CurrentUser.isStudent()) {
				return this.renderStudentHeader()
			} else if (CurrentUser.isAdmin()) {
				return this.renderAdminHeader()
			} else if (CurrentUser.isWizard()) {
				return this.renderWizardHeader()
			} else if (CurrentUser.isSponsor()) {
				return this.renderSponsorHeader()
			}
		} else {
			return this.renderLoadingHeader()
		}

	}

	componentDidMount() {
		var $navbar = $(this.refs.header),
			$placeholder = $(this.refs.placeholder),
			y_pos = $navbar.offset().top,
			height = $navbar.height();

		$(document).scroll(function() {
			var scrollTop = $(this).scrollTop();

			if ((scrollTop + 20) > y_pos + height) {
				if (!$navbar.hasClass('headerFixed')) {
					$navbar.addClass("headerFixed").animate({
						top: 0
					});
					$placeholder.show();
				};
			} else if (scrollTop <= y_pos) {
				if ($navbar.hasClass('headerFixed')) {
					$navbar.removeClass("headerFixed").animate({
						top: "-54px"
					}, 0);
					$placeholder.hide();
				};
			}
		});

		$(document).on("current-user-updated", () => {
			this.forceUpdate();
		});
	}
};

SiteHeader.INFORMATION_VIEW = "information";
SiteHeader.PREFERENCES_VIEW = "preferences";
SiteHeader.STANDARDS_VIEW = "standards";
SiteHeader.GOALS_VIEW = "goals";

SiteHeader.propTypes = StrictPropTypes({
	studentLists: PropTypes.array,
});

module.exports = SiteHeader;



// WEBPACK FOOTER //
// ./modules/components/layout/SiteHeader.js